export default __webpack_public_path__ + "static/media/rightActive.bdf55399.svg";